module.exports = __webpack_public_path__ + "static/b-6e15a26c1e70cd4002149da6c88753c8.jpg";